import React from 'react';
import {Box, Grid, Typography, Button} from '@mui/material';
import ReadMoreIcon from '@mui/icons-material/ReadMore';
import {SubCategory, CategoryPoint} from "@/types";
import {useTheme} from "@mui/material/styles";
import ServiceCategoryRowGallery from "@/ui/service-category-row/service-category-row-gallery";
import {useResizeHook} from "@/lib";
import ContentTitles from "@/ui/content-titles/content-titles";
import {BUSINESS_NAME} from "@/content";
import {Theme} from '@mui/material/styles';


type ServiceCategoryRowProps = {
    category: SubCategory;
    showPoints: boolean;
    alternate: boolean;
}

const ServiceCategoryRowContent = ({category, showPoints, alternate}: ServiceCategoryRowProps) => {


    const theme = useTheme();
    const {lessThanMuiMd, isMobile} = useResizeHook();

    const localTheme = alternate ? theme.custom.brandedAlternateBackgroundBlock : theme.custom.brandedBackgroundBlock;

    const {title, description, slug, headCategory, points, images} = category;


    return (
        <Grid size={{lg: 4, md: 12, xs: 12}}
        >
            <div>
                <ContentTitles overline={`${BUSINESS_NAME} ${headCategory.categoryType}`}/>
                <Typography variant="h3"
                            component="h3"
                            id={slug}
                            sx={(theme) => ({
                                mt: 0,
                                [theme.breakpoints.down('md')]: {
                                    textAlign: 'center',
                                    justifyItems: 'center',
                                },
                                [theme.breakpoints.down('sm')]: {
                                    fontSize: '40px !important',
                                },
                            })}>
                    {title}
                </Typography>
            </div>
            {lessThanMuiMd && <ServiceCategoryRowGallery images={images}/>}
            {!isMobile && <div>
                <Typography variant="h5" component="h5"
                            sx={{
                                textAlign: lessThanMuiMd ? 'center' : 'left',
                                [theme.breakpoints.down('md')]: {
                                    fontSize: '14px',
                                },
                                [theme.breakpoints.down('sm')]: {
                                    display: 'none',
                                },
                            }}
                >
                    {description}
                </Typography>
            </div>}

            {showPoints &&
                <Box pt={4} sx={(theme) => ({
                    [theme.breakpoints.down('md')]: {
                        py: 1,
                    },
                    [theme.breakpoints.down('lg')]: {
                        display: 'grid',
                        gridTemplateColumns: 'repeat(3, 1fr)',
                        gap: 1,
                    },
                })}>
                    {(points || []).map((point: CategoryPoint, i: number) => (
                        <div key={i}>
                            <Box key={i} sx={(theme) => ({
                                display: 'flex',
                                pb: 0,
                                pt: 0,
                                // color: localTheme.color,
                                alignItems: 'center',
                                width: '100%',
                                '& > svg': {
                                    height: 40,
                                    width: 40,
                                },
                                [theme.breakpoints.down('md')]: {
                                    pb: 0,
                                    textAlign: 'left',
                                    justifyItems: 'center',
                                    mb: 1,
                                    pt: 1
                                },
                                [theme.breakpoints.down('sm')]: {
                                    m: 0,
                                    p: 0,
                                    pt: 3,
                                    display: 'flex',
                                    flexDirection: 'column',
                                },
                            })}>
                                {!!point.icon && <point.icon/>}
                                <Box sx={(theme: Theme) => ({
                                    ml: 1,
                                    [theme.breakpoints.down('sm')]: {
                                        ml: 0
                                    }
                                })}>
                                    <Typography
                                        variant="h6"
                                        component="h6"
                                        align="left"
                                        sx={(theme) => ({
                                            [theme.breakpoints.down('sm')]: {
                                                textAlign: 'center',
                                                fontSize: '14px',
                                            },
                                        })}
                                    >
                                        {point.title}
                                    </Typography>
                                </Box>
                            </Box>
                        </div>
                    ))}
                </Box>
            }
            <Box sx={(theme) => ({
                textAlign: 'left',
                [theme.breakpoints.down('lg')]: {
                    textAlign: 'center'
                },
            })}>
                <Button
                    href={`/${headCategory.categoryType}/${headCategory.slug}/${slug}`}
                    sx={(theme) => ({
                        mt: '20px',
                        [theme.breakpoints.down('lg')]: {
                            backgroundColor: localTheme.background,
                            color: localTheme.color,
                            textAlign: 'center',
                        },

                    })}
                    variant="outlined"
                    startIcon={<ReadMoreIcon/>}
                >
                    {title}
                </Button>
            </Box>
        </Grid>
    )
};

export default ServiceCategoryRowContent;
